import { render, staticRenderFns } from "./shake.vue?vue&type=template&id=5a799362&scoped=true"
import script from "./shake.vue?vue&type=script&lang=js"
export * from "./shake.vue?vue&type=script&lang=js"
import style0 from "./shake.vue?vue&type=style&index=0&id=5a799362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a799362",
  null
  
)

export default component.exports